import editors from "./editors";

export default {
    editors: editors
}